import { useState } from "react";
import type { ImeiOut } from "@/lib/api";
import ImeiChip from "@/ui/ImeiChip";
import { useToast } from "@/ui/Toast";
import { copiarTexto } from "@/lib/copiar";

// Preferencia global (no por caso): si lo ocultas, se queda oculto en
// todos los casos hasta que lo vuelvas a abrir.
const KEY = "arktickets-equipos-resumen-abierto";

/**
 * Franja colapsable con los IMEIs del caso, arriba de las pestañas: la
 * lista a la vista mientras escribes en la bitácora, sin brincar al tab
 * de IMEIs (que conserva toda su funcionalidad). Clic en un chip copia
 * el IMEI al portapapeles. Cómo se usa lo explica la Ayuda del caso.
 */
export default function CasoEquiposResumen({ imeis }: { imeis: ImeiOut[] }) {
  const toast = useToast();
  const [abierto, setAbierto] = useState<boolean>(() => {
    try {
      return localStorage.getItem(KEY) !== "0";
    } catch {
      return true;
    }
  });

  if (imeis.length === 0) return null;

  function toggle() {
    setAbierto((v) => {
      try {
        localStorage.setItem(KEY, v ? "0" : "1");
      } catch {
        // localStorage bloqueado — el estado vive solo en esta vista.
      }
      return !v;
    });
  }

  async function copiar(imei: string) {
    if (await copiarTexto(imei)) toast.success("IMEI copiado", imei);
    else toast.error("No pude copiar el IMEI", imei);
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <button
        type="button"
        onClick={toggle}
        aria-expanded={abierto}
        className="text-[11px] uppercase tracking-wide text-zinc-400 hover:text-zinc-200 transition whitespace-nowrap"
      >
        {abierto ? "▾" : "▸"} Equipos ({imeis.length})
      </button>
      {abierto &&
        imeis.map((i) => (
          <button
            key={i.id}
            type="button"
            onClick={() => void copiar(i.imei)}
            aria-label={`Copiar IMEI ${i.imei}`}
            className="transition hover:opacity-75"
          >
            <ImeiChip imei={i} />
          </button>
        ))}
    </div>
  );
}
